export default "__VITE_ASSET__Dyd7Z3Aq__"